import React, { Component } from 'react';
import CustomSlider from './custom.slider';
import images from './data/images';
import Header from './header';
import Footer from './footer';
import Pic1 from './data/pic1.jpg';
import Pic2 from './data/pic2.jpg';
import Pic3 from './data/pic3.jpg';
import CustomerPic1 from './data/customers_Pic_1.jpg';
import CustomerPic2 from './data/customers_Pic_2.jpg';
import CustomerPic3 from './data/customers_Pic_3.jpg';
import CustomerPic4 from './data/customers_Pic_4.jpg';
import CustomerPic5 from './data/customers_Pic_5.jpg';
import CustomerPic6 from './data/customers_Pic_6.jpg';
import CustomerLogo1 from './data/customer_logo_1.png';
import CustomerLogo2 from './data/customer_logo_2.png';
import CustomerLogo3 from './data/customer_logo_3.png';
import CustomerLogo4 from './data/customer_logo_4.jpg';
import CustomerLogo5 from './data/customer_logo_5.png';
import CustomerLogo6 from './data/customer_logo_6.png';
import CustomerLogo7 from './data/customer_logo_7.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Link } from "react-router-dom";

class Home extends Component {
    
    state = {  } 
    constructor(props) {
        super(props);
        window.scroll(0, 0);
    }
    render() { 
   
        
        return (
            <div className='d-flex flex-column min-vh-100 '>
                
                <Header 
                    onlanguage={this.props.onlanguage}
                    onChangeLanguage={this.props.onChangeLanguage}
                    onEngLanguage={this.props.onEngLanguage}
                    onGeoLanguage={this.props.onGeoLanguage}
                />
                
                
                <CustomSlider>
                    {images.map((image, index) => {
                    return <img key={index} src={image.imgURL} alt={image.imgAlt} />;
                    })}
                </CustomSlider>
                
                
                <div className='d-flex justify-content-center custom-font-size-heading-3 px-4 px-md-5 my-4'>
                    
                    <div className={this.props.onEngLanguage()}>Your partner in saving Time and Resources</div>
                    <div className={this.props.onGeoLanguage()}>დაზოგე დრო და რესურსი ჩვენთან ერთად</div>
                </div>
                <div className='flex-grow-1'>
                    <div className='container-fluid w-100 m-0 p-0 border-top'>
                        <div className='row w-100 p-0 m-0'>
                            <div className='col-12 col-md-5 d-md-none d-block p-0'>
                                <img src={Pic1} alt="pic1" style={{maxWidth: '100%'}}/>
                            </div>
                            <div className='col-12 col-md-7 px-4 px-sm-5 px-md-3 px-lg-4 px-xl-5 pb-3 pb-md-0' style={{backgroundColor: '#F0F0F0', lineHeight: '2'}}>
                                <div className='mt-2 mt-md-2 mt-lg-3 mt-xxl-4' style={{color: '#4590B8'}} >
                                    <div className='custom-font-size-heading'>
                                        <b>
                                            <div className={this.props.onEngLanguage()}>Who we are</div>
                                        </b>
                                    </div>
                                    <div className='custom-font-size-heading-geo-2'>
                                        <b>
                                            <div className={this.props.onGeoLanguage()}>ჩვენი საქმიანობა</div>
                                        </b>
                                    </div>
                                </div>
                                

                                <div className='custom-font-size-text mt-2 mt-md-1 mt-lg-3 mt-xxl-4' style={{ textAlign: 'justify', textJustify: 'inter-word'}}>
                                    <div className={this.props.onEngLanguage()}>
                                        <div>
                                            We provide <b>Risk Management Consulting and Training services</b> to the organizations.
                                        </div>
                                        <div>
                                            We support organizations to develop and implement Risk management practices that enable them to:
                                        </div>
                                        <div className='px-lg-4'>
                                            <ul className='m-1' style={{listStyle: 'square'}}>
                                                <li> 
                                                    <b>Minimize</b> financial and reputational losses
                                                </li>
                                                <li>           
                                                    Comply with <b>regulatory requirements</b>
                                                </li>
                                                <li>
                                                    Pursue <b>Risk opportunities </b>
                                                </li>
                                                <li>
                                                    Effectively <b>manage crises</b>
                                                </li>
                                            </ul>
                                        </div>
                                        <div>
                                            We offer training and awareness programs for Risk managers and business stakeholders.
                                        </div>
                                            
                                        <div>
                                            We strongly believe that proactive and comprehensive risk management is
                                            crucial for <b>financial stability and operational resilience</b>. The
                                            forward-looking approach to risk management assists organizations in achieving
                                            their strategic objectives and provides a <b>competitive advantage.</b>
                                        </div>
                                    </div>
                                </div>
                                <div className='custom-font-size-text-geo-2 mt-2 mt-md-1 mt-lg-3 mt-xxl-4' style={{ textAlign: 'justify', textJustify: 'inter-word'}}>
                                    <div className={this.props.onGeoLanguage()}>
                                        <div>
                                            <div>
                                                თანამედროვე ცვალებად ბიზნეს გარემოში, სადაც ახალი რისკები ყოველდღიურად იჩენს თავს, 
                                                გადამწყვეტი მნიშვნელობა აქვს <b>რისკის მართვას</b>. 
                                            </div>
                                            <div>
                                                ჩვენ ვეხმარებით ჩვენს კლიენტებს გაუმკლავდნენ ახალ გამოწვევებს, რისკის მართვის ეფექტური
                                                მიდგომების დანერგვითა და კონტროლის გარემოს გაუმჯობესებით.   
                                            </div>
                                            <div>
                                                ჩვენ გთავაზობთ <b>ინოვაციურ</b> და <b>ეფექტურ გადაწყვეტილებებს</b>, მორგებულს თქვენი ბიზნესის
                                                საჭიროებებზე, რომელიც უზრუნველყოფს თქვენს ფინანსურ სტაბილურობასა და ოპერაციულ 
                                                მდგრადობას.  
                                                
                                            </div>
                                            <div>
                                                ჩვენთან თანამშრომლობა გაძლევთ შესაძლებლობას:
                                            </div>
                                            <div className='px-lg-4'>
                                                <ul className='m-1' style={{listStyle: 'square'}}>
                                                    <li><b>აირიდოთ</b> ფინანსური და რეპუტაციული დანაკარგები</li>
                                                    <li>აწარმოოთ საქმიანობა <b>რეგულაციებთან შესაბამისობაში</b></li>
                                                    <li><b>მართოთ რისკი</b> და სრულად გამოიყენოთ შესაძლებლობები</li>
                                                    <li>იყოთ მდგრადი და ეფექტურად <b>მართოთ კრიზისი</b></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-5 d-md-block d-none m-0 p-0'>
                                    <img src={Pic1} alt="pic1" style={{maxWidth: '100%'}}/>
                            </div>
                        </div>
                        <div className='row w-100 p-0 m-0'>
                            <div className='col-12 col-md-5 m-0 p-0'>
                                    <img src={Pic2} alt="pic2" style={{maxWidth: '100%'}}/>
                            </div>
                            <div className='col-12 col-md-7 px-4 px-sm-5 px-md-3 px-lg-4 px-xl-5 pb-3 pb-md-0' style={{backgroundColor: '#F0F0F0', lineHeight: '2'}}>
                                <div className='custom-font-size-heading mt-2 mt-md-2 mt-lg-3 mt-xxl-4' style={{color: '#4590B8'}} >
                                    <b>
                                        <div className={this.props.onEngLanguage()}>What we do</div>
                                    </b>
                                </div>
                                <div className='custom-font-size-heading-geo-2 mt-2 mt-md-2 mt-lg-3 mt-xxl-4' style={{color: '#4590B8'}} >
                                    <b>
                                        <div className={this.props.onGeoLanguage()}>ჩვენი მომსახურება</div>
                                    </b>
                                </div>
                                <div className='custom-font-size-text mt-2 mt-md-1 mt-lg-3 mt-xxl-4' style={{ textAlign: 'justify', textJustify: 'inter-word'}}>
                                    <div className={this.props.onEngLanguage()}>
                                        <div>
                                            We support organizations to:
                                        </div>
                                        <ul className='m-1' style={{listStyle: 'square'}}>
                                            <li>
                                                Design and implement <b>Risk management frameworks</b> (ORM, ERM, FRM, BCM, IS)
                                            </li>
                                            <li> 
                                                Develop implementation plans for the upcoming <b>Regulatory requirements</b>
                                            </li>
                                            <li>
                                                Design and implement Risk management requirements to support <b>licensing process</b>
                                            </li>
                                            <li>
                                                Perform Risk Maturity assessment against <b>International standards</b> (Basel, ISO, EBA, COSO) to identify areas for improvement
                                            </li>
                                            <li>
                                                Conduct a <b>Benchmarking analysis </b>
                                            </li>
                                            <li>
                                                Design and implement Risk management <b>Strategic initiatives</b>
                                            </li>
                                            <li>
                                                Design and maintain risk management <b>Training and Awareness</b> programs for employees
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className='custom-font-size-text-geo-2 mt-2 mt-md-1 mt-lg-3 mt-xxl-4' style={{ textAlign: 'justify', textJustify: 'inter-word'}}>
                                    <div className={this.props.onGeoLanguage()}>
                                        <div>
                                            ჩვენ გთავაზობთ რისკის მართვის <b>საკონსულტაციო მომსახურებას</b>, რომელიც დაგეხმარებათ რისკის მართვის პროგრამების 
                                            შემუშავებასა და განვითარებაში. ჩვენ გაგიწევთ მხარდაჭერას ახალი რეგულაციებისა და/ან ლიცენზირების მოთხოვნების
                                            ინტერპრეტირებასა და დანერგვის პროცესში. ჩვენ გთავაზობთ თქვენი მოქმედი პრაქტიკის  
                                            საერთაშორისო სტანდარტებთან (ISO,COSO,EBA,Basel) შესაბამისობის ანალიზსა და  
                                            გაუმჯობესების შესაძლებლობების გამოვლენას.  <Link to="/consulting"><i>გაიგე მეტი</i></Link>
                                        </div>
                                        {/*
                                        <div>
                                            ჩვენი მომსახურება მოიცავს: 
                                        </div>
                                        <ul className='m-1' style={{listStyle: 'square'}}>
                                            <li>
                                                მართვის პროგრამების დანერგვასა და განვითარებას                                          </li>
                                            <li> 
                                                ახალი რეგულაციებისა და/ან ლიცენზირების მოთხოვნების სამოქმედო გეგმის შემუშავებასა და დანერგვის მხარდაჭერას
                                            </li>
                                            <li>
                                                რისკის პროგრამების გეპ-ანალიზსა და საერთაშორისო პრაქტიკებთან (ISO, COSO, EBA) შესაბამისობის შეფასებასა და გაუმჯობესების შესაძლებლობების გამოვლენას                                            </li>
                                            <li>
                                                სტრატეგიული ინიციატივების შემუშავებასა და იმპლემენტაციის მხარდაჭერას.
                                            </li>
                                        </ul>
                                        */}
                                        <div>
                                            ჩვენ გთავაზობთ რისკის მართვის <b>აუთსორსინგულ მომსახურებას</b>, რომელიც გულისხმობს თქვენს კომპანიაში არსებული რისკების იდენტიფიკაციას, შეფასებასა და მონიტორინგს. 
                                            ჩვენ გაგიწევთ მხარდაჭერას ახალი სტრატეგიული ინიციატივების შემუშავებაში, დაგეხმარებით გაიუმჯობესოთ ოპერაციული მდგრადობა და შეინარჩუნოთ გრძელვადიანი ფინანსური სტაბილურობა. 
                                        </div>
                                        <div>
                                            ჩვენ გთავაზობთ რისკის მართვის <b>ტრენინგ-პროგრამებს</b>, რომელიც გაზრდის თქვენი გუნდის პროფესიულ კომპეტენციას და  
                                            დაეხმარება მათ წარმატებით განავითარონ კომპანიაში რისკის მართვის პროცესები. <Link to="/training"><i>გაიგე მეტი</i></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='row w-100 p-0 m-0'>
                            <div className='col-12 col-md-5 d-md-none d-block m-0 p-0'>
                                <img src={Pic3} alt="pic3" style={{maxWidth: '100%'}}/>
                            </div>
                            <div className='col-12 col-md-7 px-4 px-sm-5 px-md-3 px-lg-4 px-xl-5 pb-3 pb-md-0' style={{backgroundColor: '#F0F0F0', lineHeight: '2'}}>
                                <div className='custom-font-size-heading mt-2 mt-md-2 mt-lg-3 mt-xxl-4' style={{color: '#4590B8'}} > 
                                    <b>
                                        <div className={this.props.onEngLanguage()}>Our features</div>
                                    </b>
                                </div>
                                <div className='custom-font-size-heading-geo-2 mt-2 mt-md-2 mt-lg-3 mt-xxl-4' style={{color: '#4590B8'}} > 
                                    <b>
                                        <div className={this.props.onGeoLanguage()}>ჩვენი უპირატესობები</div>
                                    </b>
                                </div>
                                
                                <div className='custom-font-size-text mt-2 mt-md-1 mt-lg-3 mt-xxl-4' style={{ textAlign: 'justify', textJustify: 'inter-word'}}>
                                    <div className={this.props.onEngLanguage()}>
                                        <ul className='m-1' style={{listStyle: 'square'}}>
                                            <li> 
                                                <b>Extensive knowledge</b> of International standards and regulatory
                                                requirements
                                            </li>
                                            <li>
                                                <b>Solid experience</b> of establishing, developing and implementing Risk management frameworks and practices
                                            </li>
                                            <li>
                                                <b>Tailored solutions</b> customized strategic initiatives aligned with your specific business objectives
                                            </li>
                                            <li>
                                                <b>Proactive approach </b>that helps you identify and mitigate potential threats before they impact your operations
                                            </li>
                                            <li>
                                                <b>Value for Investment</b> identifying risk opportunities for high-return investments
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className='custom-font-size-text-geo-2 mt-2 mt-md-1 mt-lg-3 mt-xxl-4' style={{ textAlign: 'justify', textJustify: 'inter-word'}}>
                                    <div className={this.props.onGeoLanguage()}>
                                        <ul className='m-1' style={{listStyle: 'square'}}>
                                            <li>ჩვენ გვაქვს რისკის მართვის პროგრამების განვითარების <b>მრავალწლიანი გამოცდილება</b>.                                                
                                    </li>
                                            <li>ჩვენ გუნდს გააჩნია <b>სიღრმისეული ცოდნა </b> რისკის მართვის საერთაშორისო სტანდარტებისა და რეგულატორული მოთხოვნების მიმართულებით.</li>
                                            <li>ჩვენ გვაქვს <b>პროფესიული კომპეტენცია</b> ვუპასუხოთ თქვენი ბიზნესის გამოწვევებს და
                                    შემოგთავაზოთ თქვენზე მორგებული სტრატეგიული ინიციატივები.</li>
                                            <li>ჩვენ ორიენტირებული ვართ <b>პრაქტიკულ მიდგომების </b> დანერგვასა და თვლადი შედეგების
                                    მიღწევაზე;</li>   
                                        </ul>   
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-5 d-md-block d-none m-0 p-0'>
                                <img src={Pic3} alt="pic3" style={{maxWidth: '100%'}}/>
                            </div>

                        </div>
                    </div>
                    <div className='custom-font-size-heading px-5 mt-4' style={{color: '#4590B8'}}>
                        <b>
                            <div className={this.props.onEngLanguage()}>Our customers</div>
                            <div className={this.props.onGeoLanguage()}>ჩვენი მომხმარებლები</div>
                        </b>
                    </div>
                    <div className='container-fluid w-100 m-0 p-0'>
                        <div className='row w-100 p-0 m-0' >
                            <div className='col-12 col-md-6 col-lg-4 col-xl-2 m-0 px-5 pb-5 pt-4'>
                                <div className='d-block position-relative' >
                                    <img src={CustomerLogo1} alt="Customer_Pic_1" className='rounded' style={{maxWidth: '100%'}}/>
                                    
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-lg-4 col-xl-2 m-0 px-5 pb-5 pt-4'>
                                <div className='d-block position-relative' >
                                    <img src={CustomerLogo7} alt="Customer_Pic_7" className='rounded' style={{maxWidth: '100%'}}/>
                                    
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-lg-4 col-xl-2 m-0 px-5 pb-5 pt-4'>
                                <div className='d-block position-relative' >
                                    <img src={CustomerLogo3} alt="Customer_Pic_3" className='rounded' style={{maxWidth: '100%'}}/>
                                    
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-lg-4 col-xl-2 m-0 px-5 pb-5 pt-4'>
                                <div className='d-block position-relative' >
                                    <img src={CustomerLogo4} alt="Customer_Pic_4" className='rounded' style={{maxWidth: '100%'}}/>
                                    
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-lg-4 col-xl-2 m-0 px-5 pb-5 pt-4'>
                                <div className='d-block position-relative' >
                                    <img src={CustomerLogo5} alt="Customer_Pic_5" className='rounded' style={{maxWidth: '100%'}}/>
                                    
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-lg-4 col-xl-2 m-0 px-5 pb-5 pt-4'>
                                <div className='d-block position-relative' >
                                    <img src={CustomerLogo6} alt="Customer_Pic_6" className='rounded' style={{maxWidth: '100%'}}/>
                                    
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-lg-4 col-xl-2 m-0 px-5 pb-5 pt-4'>
                                <div className='d-block position-relative' >
                                    <img src={CustomerLogo2} alt="Customer_Pic_2" className='rounded' style={{maxWidth: '100%'}}/>
                                    
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div className='custom-font-size-heading px-5 mt-4' style={{color: '#4590B8'}}>
                        <b>
                            <div className={this.props.onEngLanguage()}>Who we serve</div>
                            <div className={this.props.onGeoLanguage()}>ჩვენ ვემსახურებით</div>
                        </b>
                    </div>
                    <div className='container-fluid w-100 m-0 p-0'>
                        <div className='row w-100 p-0 m-0' >
                            <div className='col-12 col-md-6 col-lg-4 m-0 px-5 pb-5 pt-4'>
                                <div className='d-block position-relative' >
                                    <img src={CustomerPic1} alt="Customer_Pic_1" className='rounded' style={{maxWidth: '100%'}}/>
                                    <div className='position-absolute bottom-0 start-50 translate-middle-x' style={{color: 'white', width: '100%', textAlign: 'center'}} >
                                        <div className='h5 mb-3 py-1' style={{backgroundColor: '#003968'}}>
                                            Commercial bank
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-lg-4 m-0 px-5 pb-5 pt-4'>
                                <div className=''>
                                    <div className='d-block position-relative' >
                                        <img src={CustomerPic2} alt="Customer_Pic_2" className='rounded' style={{maxWidth: '100%'}}/>
                                        <div className='position-absolute bottom-0 start-50 translate-middle-x' style={{color: 'white', width: '100%', textAlign: 'center'}} >
                                            <div className='h5 mb-3 py-1' style={{backgroundColor: '#003968'}}>
                                                Microfinance
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-lg-4 m-0 px-5 pb-5 pt-4'>
                                <div className='d-block position-relative' >
                                    <img src={CustomerPic3} alt="Customer_Pic_3" className='rounded' style={{maxWidth: '100%'}}/>
                                    <div className='position-absolute bottom-0 start-50 translate-middle-x' style={{color: 'white', width: '100%', textAlign: 'center'}} >
                                        <div className='h5 mb-3 py-1' style={{backgroundColor: '#003968'}}>
                                            Brokerage
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-lg-4 m-0 p-5 '>
                                <div className='d-block position-relative' >
                                    <img src={CustomerPic4} alt="Customer_Pic_4" className='rounded' style={{maxWidth: '100%'}}/>
                                    <div className='position-absolute bottom-0 start-50 translate-middle-x' style={{color: 'white', width: '100%', textAlign: 'center'}} >
                                        <div className='h5 mb-3 py-1' style={{backgroundColor: '#003968'}}>
                                            PSP
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-lg-4 m-0 p-5'>
                                <div className='d-block position-relative' >
                                    <img src={CustomerPic5} alt="Customer_Pic_5" className='rounded' style={{maxWidth: '100%'}}/>
                                    <div className='position-absolute bottom-0 start-50 translate-middle-x' style={{color: 'white', width: '100%', textAlign: 'center'}} >
                                        <div className='h5 mb-3 py-1' style={{backgroundColor: '#003968'}}>
                                            VASP
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-lg-4 m-0 p-5'>
                                <div className='d-block position-relative' >
                                    <img src={CustomerPic6} alt="Customer_Pic_6" className='rounded' style={{maxWidth: '100%'}}/>
                                    <div className='position-absolute bottom-0 start-50 translate-middle-x' style={{color: 'white', width: '100%', textAlign: 'center'}} >
                                        <div className='h5 mb-3 py-1' style={{backgroundColor: '#003968'}}>
                                            Insurance
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <br />
                </div>
             
                <Footer
                    onlanguage={this.props.onlanguage}
                    onChangeLanguage={this.props.onChangeLanguage}
                    onEngLanguage={this.props.onEngLanguage}
                    onGeoLanguage={this.props.onGeoLanguage}
                />

            </div>
        );
    }
}
    
export default Home;